import { Component, Input } from '@angular/core';
import { KeyValueItem } from '../../../../model/general.model';

@Component({
  selector: 'attribute-item',
  templateUrl: './attribute-item.component.html',
  styleUrls: ['./attribute-item.component.scss']
})
export class AttributeItemComponent {
  @Input() item: KeyValueItem;
}
